import React from 'react';

const Organisation = React.createContext({
    _refresh: () => null,
    organisation: {}
});

export default Organisation;